import { APP_INITIALIZER } from '@angular/core';

import { PRELOADER_INTERCEPTOR_PROVIDER } from './preloader.interceptor';
import { PreloaderService } from './preloader.service';

export const PRELOADER_CONTROL_PROVIDERS = [
  PRELOADER_INTERCEPTOR_PROVIDER,
  {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [PreloaderService],
    useFactory: () => () => null
  }
];
